module.exports = __webpack_public_path__ + "static/7-d5482e08a9ddf9ed94a42d4d411a7b1c.jpg";